const FORM_PDF_MODAL_SELECTOR = '[data-form-pdf-modal]';

const initFormPdfModals = () => {
    if (!window.$ || !window.$.fancybox) {
        return;
    }

    const links = document.querySelectorAll(FORM_PDF_MODAL_SELECTOR);

    if (!links.length) {
        return;
    }

    window.$(FORM_PDF_MODAL_SELECTOR).fancybox({
        baseClass: 'form-pdf-fancybox',
        buttons: [],
        iframe: {
            css: {
                width: '820px',
                height: '680px',
            },
        },
        smallBtn: true,
        toolbar: false,
    });
};

document.addEventListener('DOMContentLoaded', initFormPdfModals);
